export default __webpack_public_path__ + "three.min-2d359c0a4ca92a5786e984acdbf65f3a.js";